module.exports = __webpack_public_path__ + "img/translationeditor_13.ad5947b5.jpg";